import { useStore } from 'effector-react';
import { $isTeamAccount } from '@stores/memberStores';

export function teamConfig<T>(value: T, teamValue: T): T {
  const isTeamAccount = $isTeamAccount.getState();
  return isTeamAccount ? teamValue : value;
}

export function useTeamConfig<T>(value: T, teamValue: T): T {
  const isTeamAccount = useStore($isTeamAccount);
  return isTeamAccount ? teamValue : value;
}
